<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">Stock Build Requests</div>
                    <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="goToAdd">
                        <span>Add</span>
                    </button>
                </div>

                <div class="forms-container approval-list-shell">
                    <div v-if="successMessage" class="approval-alert approval-alert-success">
                        {{ successMessage }}
                    </div>

                    <div v-if="errorMessage" class="approval-alert approval-alert-error">
                        {{ errorMessage }}
                    </div>

                    <div v-if="!submitterEmail" class="approval-alert approval-alert-error">
                        Unable to identify your email address. Please sign in again before viewing submitted requests.
                    </div>

                    <vue-good-table
                        ref="StockBuildRequestFormList"
                        mode="remote"
                        @on-page-change="onPageChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                            enabled: true,
                            mode: 'pages',
                            pageLabel: 'Page',
                            position: 'bottom',
                            perPage: serverParams.perPage,
                            perPageDropdown: [25, 50, 100, 200, 500],
                            dropdownAllowAll: false,
                        }"
                        :search-options="{
                            enabled: false,
                        }">
                        <template slot="table-row" slot-scope="props">
                            <div v-if="props.column.field == 'Status'">
                                <span :class="'approval-status approval-status-' + props.row.Status.toLowerCase()">
                                    {{ props.row.Status }}
                                </span>
                            </div>
                            <div v-else-if="props.column.field == 'BodyQuotes'">
                                {{ quoteNames(props.row.BodyQuotes) }}
                            </div>
                            <div v-else-if="props.column.field == 'Action'">
                                <router-link v-if="canEdit(props.row)" title="Edit Request" class="btn edit-btn-vvg waves-effect"
                                    :to="{ name: 'StockBuildRequestFormEdit', params: { id: props.row.Id } }">
                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                </router-link>
                            </div>
                            <div v-else>
                                {{ props.formattedRow[props.column.field] }}
                            </div>
                        </template>
                    </vue-good-table>
                </div>
            </div>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';
    import Footer from '@/components/partials/Footer';
    import {HTTP} from '../../http-common.js';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);

    var self;

    export default {
        name: 'StockBuildRequestFormList',
        components: {
            'app-footer': Footer,
        },
        data() {
            return {
                rows: [],
                totalRecords: 0,
                isLoading: false,
                successMessage: '',
                errorMessage: '',
                // Set from the list response; the API is the authority on
                // this, never anything read out of localStorage.
                canEditRequests: false,
                baseColumns: [
                    {
                        label: 'Submitted',
                        field: 'CreatedAt',
                        filterable: true,
                        sortable: true,
                        formatFn: this.formatDate,
                        filterOptions: {
                            enabled: true,
                            placeholder: 'DD-MM-YYYY',
                            filterValue: '',
                            trigger: 'enter',
                        },
                    },
                    {
                        label: 'Dealership',
                        field: 'Dealership',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true,
                            placeholder: 'Dealership',
                            filterValue: '',
                            trigger: 'enter',
                        },
                    },
                    {
                        label: 'Make',
                        field: 'Make',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true,
                            placeholder: 'Make',
                            filterValue: '',
                            trigger: 'enter',
                        },
                    },
                    {
                        label: 'Series',
                        field: 'Series',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true,
                            placeholder: 'Series',
                            filterValue: '',
                            trigger: 'enter',
                        },
                    },
                    {
                        label: 'Model Description',
                        field: 'ModelDescription',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true,
                            placeholder: 'Model Description',
                            filterValue: '',
                            trigger: 'enter',
                        },
                    },
                    {
                        label: 'Unit ID',
                        field: 'UnitId',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true,
                            placeholder: 'Unit ID',
                            filterValue: '',
                            trigger: 'enter',
                        },
                    },
                    {
                        label: 'Commission Number',
                        field: 'CommissionNumber',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true,
                            placeholder: 'Commission Number',
                            filterValue: '',
                            trigger: 'enter',
                        },
                    },
                    {
                        label: 'Body Type',
                        field: 'BodyType',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true,
                            placeholder: 'Body Type',
                            filterValue: '',
                            trigger: 'enter',
                        },
                    },
                    {
                        label: 'Target Customer',
                        field: 'TargetCustomer',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true,
                            placeholder: 'Target Customer',
                            filterValue: '',
                            trigger: 'enter',
                        },
                    },
                    {
                        label: 'Body Quotes',
                        field: 'BodyQuotes',
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: 'Status',
                        field: 'Status',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true,
                            placeholder: 'Status',
                            filterValue: '',
                            trigger: 'enter',
                        },
                    },
                    {
                        label: 'Actioned By',
                        field: 'ActionedBy',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true,
                            placeholder: 'Actioned By',
                            filterValue: '',
                            trigger: 'enter',
                        },
                    },
                    {
                        label: 'Sales Person',
                        field: 'SubmittedByName',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true,
                            placeholder: 'Sales Person',
                            filterValue: '',
                            trigger: 'enter',
                        },
                    },
                    {
                        label: 'Actioned At',
                        field: 'ActionedAt',
                        filterable: true,
                        sortable: true,
                        formatFn: this.formatDate,
                        filterOptions: {
                            enabled: true,
                            placeholder: 'DD-MM-YYYY',
                            filterValue: '',
                            trigger: 'enter',
                        },
                    },
                ],
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 50,
                    sort: {
                        field: 'CreatedAt',
                        type: 'desc',
                    },
                },
            };
        },
        computed: {
            columns() {
                if (!this.canEditRequests) {
                    return this.baseColumns;
                }

                return this.baseColumns.concat([{
                    label: 'Action',
                    field: 'Action',
                    filterable: false,
                    sortable: false,
                    width: '90px',
                }]);
            },
            submitterEmail() {
                try {
                    var user = JSON.parse(localStorage.getItem('user_obj') || '{}');
                    return user.username || '';
                } catch (e) {
                    return '';
                }
            },
        },
        beforeMount() {
            self = this;
        },
        mounted() {
            if (this.$route.query.success) {
                this.successMessage = this.$route.query.success;
                this.$router.replace({ query: {} });
            }
            this.loadRows();
        },
        methods: {
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            onPageChange(params) {
                self.updateParams({ page: params.currentPage });
                self.loadRows();
            },
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({ perPage: params.currentPerPage });
                    self.loadRows();
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                self.serverParams.page = 1;
                self.loadRows();
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadRows();
            },
            loadRows() {
                self.errorMessage = '';

                if (!self.submitterEmail) {
                    return;
                }

                var config = {
                    headers: { Authorization: "Bearer " + localStorage.getItem("tkn") },
                };

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    SubmittedBy: self.submitterEmail,
                };

                HTTP.post('/stock-build-request-forms/list', fields, config).then(function (response) {
                    if (response.data.code == '200') {
                        self.rows = response.data.content.row || [];
                        self.totalRecords = response.data.content.totalRecords;
                        self.canEditRequests = response.data.content.canEdit === true;
                    }
                    self.isLoading = false;
                }).catch(function () {
                    self.errorMessage = 'Unable to load submitted requests.';
                    self.isLoading = false;
                });
            },
            goToAdd() {
                this.$router.push({ name: 'StockBuildRequestFormSubmission' });
            },
            canEdit(row) {
                // Editor-only, and never once the request has been approved.
                // The API enforces both again on load and on save.
                return this.canEditRequests && row.Status !== 'APPROVED';
            },
            quoteNames(quotes) {
                if (!quotes || !quotes.length) {
                    return '';
                }
                return quotes.map(function (quote) {
                    return quote.name;
                }).join(', ');
            },
            formatDate(value) {
                if (!value) {
                    return '';
                }
                return moment(value).format('DD-MM-YYYY');
            },
        },
    };
</script>

<style scoped>
    .approval-list-shell {
        padding-top: 18px;
    }

    .approval-list-table th {
        background: #f0f2f4;
        color: #222;
        font-weight: 700;
        white-space: nowrap;
    }

    .approval-list-table td {
        vertical-align: middle;
    }

    .approval-status {
        border-radius: 3px;
        display: inline-block;
        font-size: 12px;
        font-weight: 700;
        padding: 4px 8px;
    }

    .approval-status-pending {
        background: #fff3cd;
        color: #856404;
    }

    .approval-status-approved {
        background: #d4edda;
        color: #155724;
    }

    .approval-status-rejected {
        background: #f8d7da;
        color: #721c24;
    }

    .approval-alert {
        border-radius: 4px;
        font-size: 14px;
        margin-bottom: 18px;
        padding: 12px 14px;
    }

    .approval-alert-error {
        background: #fff1f1;
        border: 1px solid #f0baba;
        color: #9d2525;
    }

    .approval-alert-success {
        background: #edf8f0;
        border: 1px solid #b9e4c4;
        color: #246b35;
    }
</style>



// WEBPACK FOOTER //
// src/components/ApprovalForms/StockBuildRequestFormList.vue